import Accordion from 'react-bootstrap/Accordion';

function CheckDescrpition() {
  return (
    <Accordion flush>
      <Accordion.Item eventKey="0">
        <Accordion.Header>Write Off Status</Accordion.Header>
        <Accordion.Body className="text-start">
        Write-off vehicles typically sell for 20–50% less than comparable clean-title cars.
        In the UK there are two main categories:
        <h1></h1>
        <ul>
            <li>Category S (structural damage)</li>
            <li>Category N (non-structural damage)</li>
        </ul>     
        Clear before-and-after photos of damage and repairs signal that a write-off has been professionally assessed and properly restored.
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="1">
        <Accordion.Header>Outstanding Finance</Accordion.Header>
        <Accordion.Body className="text-start">
        1 in 6 cars on UK roads still have outstanding finance. Buying a vehicle with unpaid finance attached can leave you legally responsible for the remaining balance
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="2">
        <Accordion.Header>Stolen Status</Accordion.Header>
        <Accordion.Body className="text-start">
        If a vehicle appears on any stolen-vehicle register, it’s illegal to sell—and illegal to buy. Possessing a stolen car can lead to criminal charges, no matter how “innocent” the purchase.
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="3">
        <Accordion.Header>Number Of Keepers</Accordion.Header>
        <Accordion.Body className="text-start">
            <ul>
            <li>Single-owner cars command a premium for their clear, consistent history.</li>
            <li>Rapid turnover (e.g. five owners in five years) can signal hidden issues—spread over decades it’s less concerning.</li>
            <li>Cars with multiple previous owners often warrant a closer look at their service history and documentation.</li>
            </ul>
            <p>
            <strong>Green flag:</strong> A short, well-documented ownership history may indicate better maintenance.
            </p>
        </Accordion.Body>
      </Accordion.Item>
      <Accordion.Item eventKey="5">
        <Accordion.Header>MOT History</Accordion.Header>
        <Accordion.Body className="text-start">
        MOT history flags any outstanding issues—from corrosion and oil leaks to advisory notes—and long gaps between tests can indicate periods of neglect that warrant further investigation.
        </Accordion.Body>
      </Accordion.Item>
      {/* <Accordion.Item eventKey="5">
        <Accordion.Header>Number Plate History</Accordion.Header>
        <Accordion.Body>
            Details
        </Accordion.Body>
      </Accordion.Item> */}
    </Accordion>
  );
}

export default CheckDescrpition;